<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Arrival/Departure Country Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="arrival-departure-countrywise" :export-country="country"
                                        :export-date="range"
                                        :passport-type="passport_type"
                                        :office="office"
                                        v-if="$oauth.checkIfHasPermission(['export arrival-departure-summary-report'])"/>
          <refresh-button :click-function="updateByCountry"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs3 class="d-flex align-center">
              <custom-date-range-picker @change="updateByCountry"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="passport_types"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  label="Passport types"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="passport_type"
                  @change="updateByCountry"
              />
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="country"
                  @change="updateByCountry"
              />
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="offices"
                  clearable
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Office"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="office"
                  @change="updateByCountry"
              />
            </v-flex>

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <!--                        <v-data-table-->
            <!--                            :headers="headers"-->
            <!--                            :items="country_wise_data"-->
            <!--                            :loading="loading"-->
            <!--                            :options.sync="pagination"-->
            <!--                            :footer-props="footerProps"-->
            <!--                            class="elevation-0"-->
            <!--                            v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"-->
            <!--                            hide-default-footer>-->

            <!--                        </v-data-table>-->
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th colspan="2" style="border-bottom: 1px solid lightgray"></th>
                <th colspan="4" class="text-center"
                    style="border-right: 1px solid lightgray;border-bottom: 1px solid lightgray">Arrival
                </th>
                <th colspan="4" class="text-center" style="border-bottom: 1px solid lightgray">
                  Departure
                </th>
              </tr>
              <tr>
                <th class="text-center">S.N</th>
                <th>Country Name</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="country_wise_data">
              <tr v-for="(item,i) in country_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on">{{ item.country }}</span>
                    </template>
                    <span>{{ item.country_code }}</span>
                  </v-tooltip>
                </td>

                <td class="text-center">{{ item.male_arrived }}</td>
                <td class="text-center">{{ item.female_arrived }}</td>
                <td class="text-center">{{ item.other_arrived }}</td>
                <td class="text-center font-weight-bold">{{ item.total_arrived }}</td>
                <td class="text-center">{{ item.male_departed }}</td>
                <td class="text-center">{{ item.female_departed }}</td>
                <td class="text-center">{{ item.other_departed }}</td>
                <td class="text-center font-weight-bold">{{ item.total_departed }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_male_arrival }}</td>
                <td class="text-center">{{ total_female_arrival }}</td>
                <td class="text-center">{{ total_other_arrival }}</td>
                <td class="text-center">{{ total_total_arrival }}</td>
                <td class="text-center">{{ total_male_departure }}</td>
                <td class="text-center">{{ total_female_departure }}</td>
                <td class="text-center">{{ total_other_departure }}</td>
                <td class="text-center">{{ total_total_departure }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const AD_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/arrival-departure-countrywise`;

export default {
  name: "ADCountryWiseReport",
  data() {
    return {
      ADTypes: [
        "Arrival",
        "Departure",
        "Arrival Cancel",
        "Departure Cancel",
      ],
      country_wise_data: [],
      country_wise_arrival: [],
      country_wise_departure: [],
      office: null,
      passport_type: null,
      passport_types: ['Ordinary passport', 'Diplomatic Passport', 'Official/Service Passport', 'Laissez-passer Passport', 'Crew Passport'],
      range: {},
      country: [],
      table_data: [],
      total_male_arrival: 0,
      total_female_arrival: 0,
      total_other_arrival: 0,
      total_total_arrival: 0,
      total_male_departure: 0,
      total_female_departure: 0,
      total_other_departure: 0,
      total_total_departure: 0,
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
      officers: "UserList/all"
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      fetchOfficers: "UserList/getAll"
    }),
    getData() {
      this.table_data = [];
      let data = this.country_wise_data;
      let country_list = [];
      for (let i = 0; i < data.length; i++) {
        country_list.push(data[i].country);
      }
      let unique_country = [...new Set(country_list)];
      unique_country = unique_country.sort((a, b) => {
        let countryA = a.toUpperCase(); // ignore upper and lowercase
        let countryB = b.toUpperCase(); // ignore upper and lowercase
        if (countryA < countryB) {
          return -1; //permissionA comes first
        }
        if (countryA > countryB) {
          return 1; // permissionB comes first
        }
        return 0;
      });
      let newData = [];
      for (let k = 0; k < unique_country.length; k++) {
        let arrive_male_traveller = 0;
        let arrive_female_traveller = 0;
        let depart_male_traveller = 0;
        let depart_female_traveller = 0;
        let newSet = {'country': unique_country[k]};
        for (let j = 0; j < data.length; j++) {
          if (unique_country[k] === data[j].country && data[j].status.toLowerCase() === 'arrived') {
            newSet['arrived'] = data[j].visit;
            arrive_male_traveller += data[j].male_traveller;
            arrive_female_traveller += data[j].female_traveller;
          }
          if (unique_country[k] === data[j].country && data[j].status.toLowerCase() === 'departed') {
            newSet['departed'] = data[j].visit;
            depart_male_traveller += data[j].male_traveller;
            depart_female_traveller += data[j].female_traveller;
          }
        }
        newSet['arrived_male'] = arrive_male_traveller;
        newSet['arrived_female'] = arrive_female_traveller;
        newSet['departed_male'] = depart_male_traveller;
        newSet['departed_female'] = depart_female_traveller;
        newData.push(newSet);
      }
      this.table_data = newData;
    },
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });

    },
    departedReport(item) {
    },
    updateByCountry() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;

      if (this.office)
        params.office_id = this.office

      if (this.passport_type)
        params.passport_type = this.passport_type

      this.total_male_arrival = 0;
      this.total_female_arrival = 0;
      this.total_other_arrival = 0;

      this.total_male_departure = 0;
      this.total_female_departure = 0;
      this.total_other_departure = 0;
      this.total_total_arrival = 0
      this.total_total_departure = 0
      Http.get(AD_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.country_wise_data = res.data.data;
            this.country_wise_data.forEach(item => {
              this.total_male_arrival += item.male_arrived;
              this.total_female_arrival += item.female_arrived;
              this.total_other_arrival += item.other_arrived;

              this.total_male_departure += item.male_departed;
              this.total_female_departure += item.female_departed;
              this.total_other_departure += item.other_departed;
            })
            this.total_total_arrival = this.total_other_arrival + this.total_female_arrival + this.total_male_arrival
            this.total_total_departure = this.total_other_departure + this.total_female_departure + this.total_male_departure
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    },
  },
  mounted() {
    if (this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }
    this.progressLinearLoading = true;
    Http.get(AD_SUMMARY_REPORT_URL)
        .then((res) => {
          this.country_wise_data = res.data.data;
          this.country_wise_data.forEach(item => {
            this.total_male_arrival += item.male_arrived;
            this.total_female_arrival += item.female_arrived;
            this.total_other_arrival += item.other_arrived;

            this.total_male_departure += item.male_departed;
            this.total_female_departure += item.female_departed;
            this.total_other_departure += item.other_departed;
          })
          this.total_total_arrival = this.total_other_arrival + this.total_female_arrival + this.total_male_arrival
          this.total_total_departure = this.total_other_departure + this.total_female_departure + this.total_male_departure
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });
    if (this.$store.state.OfficeList.offices.length === 0) {
      this.$store.dispatch("OfficeList/fetchData");
    }

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>

